/**
 * Here we are exporting the duck reducers for easy import in the store. Note
 * that the names used for export here typically respond to the keys that
 * reference the ducks in the app state.
 */
export { default as auth } from './auth';
export { default as user } from './user';
export { default as map } from './map';
export { default as segmentCreation } from './segmentCreation';
export { default as routeCreation } from './routeCreation';



// WEBPACK FOOTER //
// ./src/state/ducks/index.js